const LoadedFlag = {
    EMPTY: 'EMPTY',
    LOADED: 'LOADED'
};
    
export default LoadedFlag;